<template>
  <div class="app-download-page">
    <div class="app-download-shell">
      <header class="app-download-header">
        <button class="back-button" @click="goHome">
          <i class="el-icon-arrow-left"></i>
          返回起号云
        </button>
        <div class="header-brand">
          <span class="brand-web">起号云</span>
          <span class="brand-divider">/</span>
          <span>多合剪辑 App</span>
        </div>
      </header>

      <main class="app-download-main">
        <section class="app-intro">
          <div class="app-logo-wrap">
            <img class="app-logo" :src="require('@/assets/img/duohe.png')" alt="多合剪辑 App logo">
          </div>
          <div class="app-intro-copy">
            <div class="brand-tag">
              <img class="brand-tag-logo" :src="require('@/assets/img/qhy2.png')" alt="起号云 logo">
              <span>起号云旗下 · 手机端 APP</span>
            </div>
            <h1>多合剪辑 App</h1>
            <p>与起号云网页版配套使用，随时随地完成视频去重、混剪和创作。</p>
          </div>
        </section>

        <section class="download-card">
          <div class="download-card-heading">
            <h2>立即下载 APP</h2>
            <p>请选择与你的设备对应的版本</p>
          </div>
          <div class="download-options">
            <button class="download-option" @click="downloadApp('ios')">
              <span class="platform-icon platform-ios">iOS</span>
              <span class="platform-copy">
                <strong>苹果设备</strong>
                <small>前往 App Store 下载</small>
              </span>
              <i class="el-icon-arrow-right download-arrow"></i>
            </button>
            <button class="download-option" @click="downloadApp('android')">
              <span class="platform-icon platform-android"><i class="el-icon-mobile-phone"></i></span>
              <span class="platform-copy">
                <strong>安卓手机</strong>
                <small>下载 Android 安装包</small>
              </span>
              <i class="el-icon-arrow-right download-arrow"></i>
            </button>
          </div>
          <p class="download-tip">支持苹果（iOS）、安卓手机等设备</p>
        </section>

        <p class="brand-note">起号云网页版与多合剪辑 App 同属一个产品体系，账号可按页面提示使用。</p>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownload',
  methods: {
    goHome() {
      this.$router.push('/')
    },
    downloadApp(platform) {
      if (platform === 'ios') {
        window.location.href = 'https://apps.apple.com/cn/app/%E5%A4%9A%E5%90%88%E5%89%AA%E8%BE%91/id6748834540'
      } else {
        window.location.href = 'https://spk.siyoa.com/qhy/app/update/duoheios/2.2.0/duohe_v2.apk'
      }
    }
  }
}
</script>

<style scoped>
.app-download-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0 24px 48px;
  color: #172033;
  background:
    radial-gradient(circle at 18% 12%, rgba(92, 140, 255, 0.16), transparent 30%),
    linear-gradient(145deg, #f4f8ff 0%, #eef3fb 100%);
}

.app-download-shell {
  width: min(960px, 100%);
  margin: 0 auto;
}

.app-download-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 76px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  color: #2563eb;
  border: 1px solid #d8e4f7;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 14px;
}

.header-brand {
  color: #64748b;
  font-size: 14px;
}

.brand-web {
  color: #2563eb;
  font-weight: 600;
}

.brand-divider {
  margin: 0 8px;
  color: #c1ccdc;
}

.app-download-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0 24px;
}

.app-intro {
  display: flex;
  align-items: center;
  gap: 28px;
  width: min(680px, 100%);
}

.app-logo-wrap {
  flex: 0 0 auto;
  width: 112px;
  height: 112px;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 18px 38px rgba(46, 65, 167, 0.22);
}

.app-logo {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.app-intro-copy {
  min-width: 0;
}

.brand-tag {
  display: inline-flex;
  position: relative;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  margin-bottom: 12px;
  padding: 6px 10px;
  color: #2563eb;
  border-radius: 999px;
  background: #e5efff;
  font-size: 13px;
}

.brand-tag::after {
  position: absolute;
  top: -50%;
  left: -35%;
  z-index: 2;
  width: 30%;
  height: 200%;
  content: '';
  pointer-events: none;
  background: linear-gradient(
    100deg,
    transparent 0%,
    rgba(255, 255, 255, 0.55) 28%,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0.55) 72%,
    transparent 100%
  );
  transform: skewX(-20deg);
  animation: brand-tag-shine 3s linear infinite;
}

.brand-tag > * {
  position: relative;
  z-index: 3;
}

@keyframes brand-tag-shine {
  0% {
    left: -45%;
    opacity: 0;
  }

  3% {
    left: -34%;
    opacity: 1;
  }

  50% {
    left: 140%;
    opacity: 0;
  }

  100% {
    left: 140%;
    opacity: 0;
  }
}

.brand-tag-logo {
  display: block;
  box-sizing: border-box;
  width: 21px;
  height: 21px;
  padding: 2px;
  border-radius: 50%;
  background: #fff;
  object-fit: cover;
}

@media (prefers-reduced-motion: reduce) {
  .brand-tag::after {
    animation: none;
  }
}

.app-intro h1 {
  margin: 0;
  color: #172033;
  font-size: clamp(30px, 5vw, 48px);
  line-height: 1.15;
}

.app-intro p {
  margin: 14px 0 0;
  color: #64748b;
  font-size: 16px;
  line-height: 1.7;
}

.download-card {
  width: min(680px, 100%);
  box-sizing: border-box;
  margin-top: 48px;
  padding: 30px;
  border: 1px solid #dce6f5;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 18px 45px rgba(35, 67, 130, 0.1);
}

.download-card-heading h2 {
  margin: 0;
  color: #172033;
  font-size: 24px;
}

.download-card-heading p {
  margin: 8px 0 0;
  color: #8190a8;
  font-size: 14px;
}

.download-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
}

.download-option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 18px 16px;
  text-align: left;
  border: 1px solid #d9e4f3;
  border-radius: 13px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.download-option:hover {
  border-color: #3b82f6;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.13);
  transform: translateY(-2px);
}

.platform-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  color: #fff;
  border-radius: 11px;
  font-size: 13px;
  font-weight: 700;
}

.platform-ios {
  background: #172033;
}

.platform-android {
  background: #22a866;
  font-size: 20px;
}

.platform-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
}

.platform-copy strong {
  color: #172033;
  font-size: 16px;
}

.platform-copy small {
  overflow: hidden;
  color: #8190a8;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-arrow {
  margin-left: auto;
  color: #8aa0c2;
}

.download-tip,
.brand-note {
  color: #8190a8;
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
}

.download-tip {
  margin: 20px 0 0;
}

.brand-note {
  max-width: 680px;
  margin: 24px 0 0;
}

@media (max-width: 640px) {
  .app-download-page {
    padding: 0 16px 32px;
  }

  .app-download-header {
    min-height: 64px;
  }

  .header-brand {
    font-size: 12px;
  }

  .app-download-main {
    padding-top: 40px;
  }

  .app-intro {
    flex-direction: column;
    align-items: center;
    gap: 14px;
    text-align: center;
  }

  .app-logo-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }

  .brand-tag {
    margin-bottom: 8px;
    padding: 5px 8px;
    font-size: 11px;
  }

  .brand-tag-logo {
    width: 21px;
    height: 21px;
  }

  .app-intro-copy {
    width: 100%;
  }

  .app-intro h1 {
    font-size: 28px;
  }

  .app-intro p {
    margin-top: 8px;
    font-size: 13px;
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
  }

  .download-card {
    margin-top: 32px;
    padding: 22px 16px;
    border-radius: 15px;
  }

  .download-card-heading h2 {
    font-size: 21px;
  }

  .download-options {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .download-option {
    padding: 15px 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppDownload.vue